<template>
  <div v-if="result" :style="{ position: 'relative', width: '100%' }">
    <div class="echarts echartpri" ref="chart" :id="id" :style="styles">	
		</div>
  </div>
</template>

<script>
import util from '../../libs/util'
import 'echarts-gl'
export default {
  name: 'myEcharts',
  components: {},
  data() {
    return {
      styles: {},
      options: {}
    }
  },
  props: {
    result: Object,
    height: [Number, String],
    id: String,
    other: {
      type: Object,
      default: function () {
        return null
      }
    }
  },
  watch: {
    height() {
      this.initial()
    },
    result() {
      this.initial()
    }
  },
  mounted() {
    this.initial()
  },
  created() {},
  methods: {
    initial() {
      this.styles = { height: this.height}
      setTimeout(() => {
        this.drawEchart()
      }, 100)
    },
    drawEchart() {
      if (document.getElementById(this.id)) {
        this.$nextTick(_ => { 
          let myChart = this.$echarts.init(this.$refs.chart)
          util.deepObject(this.result, this.options)
          if (this.other) {
            for (let p in this.other) {
              this.options[p] = this.other[p]
            }
          }
          myChart.setOption(this.options)
         // myChart.resize();
          window.addEventListener("resize", function() {      
              myChart.resize();           
          });
          window.onbeforeunload = function (e) {
            myChart.clear();  
          }
        })
      }
    }
  },
  filters: {}
}
</script>
<style>
  .echartpri{
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/home/myEcharts.vue